import { isInvoicingSessionCancelled } from "components/Dashboard/DoctorDashboard/utils/isInvoicingSessionCancelled";
import { getAppointmentPatientName } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-view/components/scrollable-calendar-view/components/appointment-timeslot/utils/getAppointmentPatientName";
import { SessionIndicatorIconsData } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-view/components/session-indicator-icons/SessionIndicatorIcons";
import SESSION_TYPE_COLORS from "components/Dashboard/utility/constants/session-type-colors";
import { getCoupleDisplayFullName } from "utils/getCoupleDisplayName";
import { isInPersonSession } from "utils/online-offline/isInPersonSession";

export const getAppointmentTitle = (appointment: AppointmentMetaData) => {
  if (appointment.couple && appointment.couple.length > 0) {
    return getCoupleDisplayFullName(appointment.couple);
  }

  return getAppointmentPatientName(appointment, true);
};

export const isAppointmentCancelled = (
  appointment: AppointmentMetaData,
  nextStatus: any = null,
) => {
  return (
    appointment.statusFlags.cancelledOrAbandoned ||
    isInvoicingSessionCancelled(appointment, nextStatus)
  );
};

export const getAppointmentSessionTypeColor = (
  appointment: AppointmentMetaData,
  sessionTypes: SessionType[],
) => {
  const sessionType = sessionTypes.find(
    (type) => type.label === appointment.appointment_type_label,
  );

  const color =
    SESSION_TYPE_COLORS.find(
      (option) => option.id === sessionType?.color_code,
    ) ?? SESSION_TYPE_COLORS[0];

  const isInThePast =
    new Date(appointment.appointment_end).valueOf() < Date.now();

  return isInThePast ? color.disabledValue : color.value;
};

export const getSessionIndicatorIconsDataForAppointment = (
  appointment: AppointmentWithSeriesInfo,
): SessionIndicatorIconsData => ({
  noteStatus: "none",
  location: isInPersonSession(appointment) ? "in-person" : "telehealth",
  repeat:
    appointment.appointment_series_id &&
    appointment.appointment_series?.repeat_rule
      ? "series"
      : "none",
  paymentMethod: appointment.statusFlags.usingInvoicing ? "invoice" : "cc-hold",
});
